import React, { useEffect, useRef, useState } from 'react';
import { useParams } from 'react-router';
import _ from 'lodash';
import { useSelector, useDispatch } from 'react-redux';
import { Box, makeStyles } from '@material-ui/core';
import Toolbar from './Toolbar';
import Message from '../Message';
import MessageAdd from '../MessageAdd';
import { addMessage } from 'src/actions/channelWeb';
import moment from 'moment';
import LoadingScreen from 'src/components/LoadingScreen';
import { useTranslation } from 'react-i18next';

const useStyles = makeStyles(() => ({
  root: {
    flexGrow: 1,
    display: 'flex',
    flexDirection: 'column',
    backgroundColor: 'white'
  },
  divider: {
    backgroundColor: 'lightgray'
  },
  sending: {
    fontWeight: 'bold',
    display: 'inline-block',
    fontFamily: 'monospace',
    fontSize: '12px',
    clipPath: 'inset(0 3ch 0 0)',
    animation: 'l 1s steps(4) infinite'
  },
  '@keyframes l ': {
    to: {
      clipPath: 'inset(0 -1ch 0 0)'
    }
  }
}));

const messagesSelector = (state, userId) => {
  let threads = state.chat.threads.allKeys.map(
    key => state.chat.threads.byKey[key]
  );
  const filtered = threads.filter(e =>
    [userId, userId.split(':')[0]].includes(e.user_id)
  );
  let messages = [];
  if (filtered.length) {
    messages = state.chat.messages.byThreadId[filtered[0].id];
  }

  return messages;
};

const threadSelector = (state, botId, userId, channel) => {
  let threads = state.chat.threads;
  return Object.values(threads.byKey).find(
    thread =>
      [userId, userId.split(':')[0]].includes(thread.user_id) &&
      thread.bot_id === botId &&
      thread.channel === channel
  );
};

function ThreadDetails({ config }) {
  const classes = useStyles();
  const dispatch = useDispatch();
  const { userId, botId } = useParams();
  // const messages = useSelector(state => messagesSelector(state, userId));
  const messages = useSelector(state =>
    messagesSelector(state, `${userId}:web:${botId}`)
  );
  const trhead = useSelector(
    // state => threadSelector(state, botId, userId, 'web')
    state => threadSelector(state, botId, `${userId}:web:${botId}`, 'web')
  );
  const [sending, setSending] = useState(false);
  const [firstLoad, setFirstLoad] = useState(true);
  const messagesEndRef = useRef(null);
  const chatBox = useRef(null);
  const { t } = useTranslation('common');

  const scrollToBottom = () => {
    if (firstLoad) {
      chatBox.current.scrollTo(0, chatBox.current.scrollHeight);
      setFirstLoad(false);
    } else {
      messagesEndRef.current.scrollIntoView({ behavior: 'smooth' });
    }
  };
  const orderedList = _.orderBy(messages, 'created_at', 'asc');

  const onAdd = async (botId, text) => {
    setSending(true);
    if (localStorage.getItem('disconnected') === 'true') {
      alert(t('withoutInternetConnection'));
      return;
    }
    dispatch(
      addMessage(botId, userId, trhead.id, {
        type: 'text',
        text
      })
    );
  };
  useEffect(() => {
    scrollToBottom();
    setSending(false);
  }, [messages]);

  return (
    <div className={classes.root}>
      {/* <Toolbar thread={undefined} />
      <Divider className={classes.divider} /> */}
      <Box
        flexGrow={1}
        p={2}
        overflow={'scroll'}
        style={{ overflowX: 'hidden' }}
        ref={chatBox}
      >
        {orderedList.length > 0 ? (
          orderedList.map((message, idx) => {
            let msg = message.pending
              ? {
                  ...message,
                  role: 'USER',
                  status: 'Pending...',
                  created_at: moment()
                }
              : message;
            return (
              <>
                <Message
                  isLast={idx + 1 === orderedList.length}
                  config={config}
                  onAdd={onAdd}
                  sending={sending}
                  key={msg.id || idx}
                  message={msg}
                />
              </>
            );
          })
        ) : (
          <LoadingScreen />
        )}
        <div ref={messagesEndRef} />
      </Box>
      <MessageAdd config={config} onAdd={onAdd} />
    </div>
  );
}

export default ThreadDetails;
